export class AddressModel {
    public itemSelected = false;
    public displayText = null;
    public address1 = null;
    public address2 = null;
    public address3 = null;
    public suburb = null;
    public stateCode = null;
    public country = 'Australia';
    public postCode = null;
    public latitude = null;
    public longitude = null;
}
